import {
  Facebook,
  Mail,
  MapPin,
  MessageCircle,
  Phone,
  Send,
} from "lucide-react";
import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { companyInfo } from "@/data/siteData";

const footerGroups = [
  {
    title: "Explore",
    links: [
      ["Travel packages", "/packages"],
      ["Destinations", "/destinations"],
      ["Plan your trip", "/plan-your-trip"],
      ["Track inquiry", "/track-inquiry"],
    ],
  },
  {
    title: "ACES Travel",
    links: [
      ["Our services", "/services"],
      ["Travel guides", "/travel-guides"],
      ["About us", "/about"],
      ["Contact", "/contact"],
    ],
  },
];

export function Footer() {
  return (
    <footer className="site-footer">
      <div className="site-footer__skyline" aria-hidden="true" />
      <div className="container">
        <div className="site-footer__top">
          <div className="site-footer__brand">
            <Logo inverse />
            <p>
              Affordable, flexible travel planning from Cauayan City—made
              easier by a real team since 2018.
            </p>
            <div className="social-links">
              {companyInfo.socialLinks.facebook ? (
                <a href={companyInfo.socialLinks.facebook} target="_blank" rel="noreferrer" aria-label="ACES Travel on Facebook"><Facebook /></a>
              ) : null}
              <a href={companyInfo.messengerUrl} target="_blank" rel="noreferrer" aria-label="Message ACES Travel"><MessageCircle /></a>
            </div>
          </div>
          {footerGroups.map((group) => (
            <div className="site-footer__links" key={group.title}>
              <h2>{group.title}</h2>
              {group.links.map(([label, path]) => (
                <Link key={path} to={path}>{label}</Link>
              ))}
            </div>
          ))}
          <div className="site-footer__contact">
            <h2>We’re here to help</h2>
            <a href={`tel:${companyInfo.phone.replace(/[^\d+]/g, "")}`}><Phone /> {companyInfo.phone}</a>
            <a href={`tel:${companyInfo.sms.replace(/[^\d+]/g, "")}`}><Phone /> {companyInfo.sms}</a>
            <a href={`mailto:${companyInfo.email}`}><Mail /> {companyInfo.email}</a>
            <p><MapPin /> {companyInfo.address}</p>
          </div>
        </div>
        <div className="site-footer__note">
          <Send aria-hidden="true" />
          <p>
            Submitting an inquiry does not confirm a reservation. Our team will
            review your request and send a personalized quotation.
          </p>
        </div>
        <div className="site-footer__bottom">
          <p>© {new Date().getFullYear()} ACES Travel & Tours Services.</p>
          <div><Link to="/privacy">Privacy</Link><Link to="/terms">Terms</Link></div>
        </div>
      </div>
    </footer>
  );
}
